import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { DocumentSaleFormType } from '../components/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<DocumentSaleFormType>();
  const [documentSales, otherCost, discount] = useWatch({
    control,
    name: ['documentSales', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = documentSales.reduce((prev, hp) => {
      const subtotalGuest = hp.documentSaleGuests
        .map((guest) => guest.details)
        .flat()
        .reduce((prev, detail) => prev + (detail.price || 0), 0);

      const subtotalAddOns = hp.documentSaleAddOns.reduce((prev, dsao) => {
        return prev + (dsao.price || 0);
      }, 0);

      return prev + subtotalGuest + subtotalAddOns;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [discount, documentSales, otherCost, setValue]);

  return data;
}
